import React, { Component } from "react";
import * as s from "./ShareButton.module.scss";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  WhatsappShareButton,
} from "react-share";
import { Icons } from "src/libs/assets";
import { graphql, StaticQuery } from "gatsby";
import { ISettings } from "src/models";
import { P } from "src/views/shared/components";
import { SkypeButton } from "./SkypeButton/SkypeButton";
import { tx } from "resource-centre-theme/src/libs/i18n";

interface ShareButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  type: "twitter" | "facebook" | "linkedin" | "email" | "whatsapp" | "skype";
  url: string;
  title?: string;
  subject?: string;
  body?: string;
  settings?: ISettings;
  label?: String;
}

export class ShareButtonComponent extends Component<ShareButtonProps> {
  renderLabelIfSet = () => {
    const { label } = this.props;

    return (
      label && (
        <P medium className={s.underlined}>
          {label}
        </P>
      )
    );
  };
  render() {
    const { type, url, title, subject, body, settings, className } = this.props;
    const { generalSettings } = settings;
    const { siteTitle } = generalSettings;

    const classes = [s.shareButtonContainer];

    if (className) {
      classes.push(className);
    }

    let formattedUrl = url;
    if (url.startsWith("/")) {
      formattedUrl = generalSettings.siteUrl + url;
    }

    switch (type) {
      case "facebook":
        return (
          <FacebookShareButton url={formattedUrl} className={classes.join(" ")}>
            <div
              className={s.shareIcon}
              data-hover={tx("icons.shareOnFacebook")}
              >
                <img
                  src={Icons.facebook_small}
                  alt="facebook icon"
                  className={s.shareIcon}
                />
            </div>
            {this.renderLabelIfSet()}
          </FacebookShareButton>
        );
      case "twitter":
        return (
          <TwitterShareButton url={formattedUrl} className={classes.join(" ")}>
            <div
              className={s.shareIcon}
              data-hover={tx("icons.shareOnTwitter")}
              >
                <img
                  src={Icons.twitter_small}
                  alt="twitter icon"
                  className={s.shareIcon}
                />
            </div>
            {this.renderLabelIfSet()}
          </TwitterShareButton>
        );
      case "linkedin":
        return (
          <LinkedinShareButton url={formattedUrl} className={classes.join(" ")}>
            <div
              className={s.shareIcon}
              data-hover={tx("icons.shareOnLinkedin")}
              >
                <img
                  src={Icons.linkedin_small}
                  alt="linkedin icon"
                  className={s.shareIcon}
                />
            </div>
            {this.renderLabelIfSet()}
          </LinkedinShareButton>
        );
      case "email":
        return (
          <EmailShareButton
            className={classes.join(" ")}
            url={formattedUrl}
            subject={subject ? subject : siteTitle}
            body={
              body
                ? body
                : `I found a resource that I would like to share with you. The resource can be viewed on the following link. \n`
            }
          >
            <div
              className={s.shareIcon}
              data-hover={tx("icons.shareOnEmail")}
              >
                <img
                  src={Icons.subscribe_small}
                  alt="email icon"
                  className={s.shareIcon}
                />
            </div>
            {this.renderLabelIfSet()}
          </EmailShareButton>
        );
      case "whatsapp":
        return (
          <WhatsappShareButton url={formattedUrl} className={classes.join(" ")}>
            <div
              className={s.shareIcon}
              data-hover={tx("icons.shareOnWhatsapp")}
              >
                <img
                  src={Icons.whatsapp_small}
                  alt="whatsapp icon"
                  className={s.shareIcon}
                />
            </div>
            {this.renderLabelIfSet()}
          </WhatsappShareButton>
        );
      case "skype":
        return <SkypeButton url={formattedUrl} />;
    }
  }
}

export const ShareButton = (props: ShareButtonProps) => (
  <StaticQuery
    query={query}
    render={data => {
      return <ShareButtonComponent {...props} settings={data.siteSettings} />;
    }}
  />
);

const query = graphql`
  query {
    ...siteSettingsFragment
  }
`;
